import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
interface BarChartVisualProps {
  data: Array<{
    label: string;
    value: number;
  }>;
  xAxisLabel?: string;
  yAxisLabel?: string;
  barColor?: string;
  hideValues?: boolean;
  mode?: 'stimulus' | 'support';
}
export function BarChartVisual({
  data,
  xAxisLabel = '',
  yAxisLabel = '',
  barColor = '#6366f1',
  hideValues = true,
  mode = 'stimulus'
}: BarChartVisualProps) {
  // In support mode, we might want to force showing values to help explain the answer
  const effectiveHideValues = mode === 'support' ? false : hideValues;
  const CustomTooltip = ({
    active,
    payload
  }: {
    active?: boolean;
    payload?: Array<{
      payload: {
        label: string;
        value: number;
      };
    }>;
  }) => {
    if (!active || !payload?.[0]) return null;
    const item = payload[0].payload;
    return <div className="bg-white px-3 py-2 rounded-lg shadow-lg border border-slate-200 text-sm" data-id="element-7439">
        <span className="font-semibold text-slate-700" data-id="element-7440">{item.label}</span>
        {!effectiveHideValues && <span className="text-slate-500 ml-2" data-id="element-7441">{item.value}</span>}
      </div>;
  };
  return <div className="w-full max-w-3xl mx-auto flex flex-col items-center" data-id="element-7442">
      <div className="w-full h-[240px] md:h-[340px] bg-white rounded-xl border border-slate-200 shadow-sm p-3 md:p-4" aria-hidden="true" data-id="element-7443">
        <ResponsiveContainer width="100%" height="100%" data-id="element-7444">
          <BarChart data={data} margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 40
        }} data-id="element-7445">
            <CartesianGrid strokeDasharray="3 3" vertical={false} data-id="element-7446" />
            <XAxis dataKey="label" interval={0} tick={{
            fill: '#64748b',
            fontSize: 12
          }} tickLine={false} axisLine={{
            stroke: '#cbd5e1'
          }} label={xAxisLabel ? {
            value: xAxisLabel,
            position: 'insideBottom',
            offset: -20,
            fill: '#475569',
            fontSize: 13,
            fontWeight: 600
          } : undefined} data-id="element-7447" />

            <YAxis tick={{
            fill: '#64748b',
            fontSize: 12
          }} tickLine={false} axisLine={false} label={yAxisLabel ? {
            value: yAxisLabel,
            angle: -90,
            position: 'insideLeft',
            fill: '#475569',
            fontSize: 14,
            fontWeight: 600
          } : undefined} data-id="element-7448" />

            <Tooltip content={<CustomTooltip data-id="element-7450" />} cursor={{
            fill: '#f1f5f9'
          }} data-id="element-7449" />

            <Bar dataKey="value" radius={[4, 4, 0, 0]} data-id="element-7451">
              {data.map((_entry, index) => <Cell key={`cell-${index}`} fill={barColor} data-id="element-7452" />)}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>;
}